import {
  ToggleButton,
  ToggleButtonGroup,
  toggleButtonGroupClasses,
} from "@mui/material";
import { styled } from "@mui/material/styles";

export const Group = styled(ToggleButtonGroup)(({ theme }) => ({
  gap: theme.spacing(0.5),
  flexWrap: "wrap",

  [`& .${toggleButtonGroupClasses.grouped}`]: {
    border: "none",
    borderRadius: theme.shape.borderRadius,
    marginLeft: 0,
  },
}));

export const Button = styled(ToggleButton)(({ theme }) => ({
  border: "none",
  borderRadius: theme.shape.borderRadius,
  padding: theme.spacing(0.75, 1),
  fontSize: 13,
  fontWeight: 500,
  lineHeight: 1,
  textTransform: "none",
  color: theme.palette.text.secondary,

  "&.Mui-selected": {
    color: theme.palette.text.primary,
    fontWeight: 700,
    backgroundColor: theme.palette.action.selected,

    "&:hover": {
      backgroundColor: theme.palette.action.selected,
    },
  },
}));
